// extracted by mini-css-extract-plugin
export default {"item":"Item_item__ZJXtO","item__imagem":"Item_item__imagem__Z2Jt0","item__descricao":"Item_item__descricao__3-M3a","item__titulo":"Item_item__titulo__yllBt"};